import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

export const RoiSummaryRow = ({ label, children }: { label: string; children: ReactNode }) => (
  <Box className="flex justify-between items-center">
    <Typography
      variant="caption"
      color="textSecondary">
      {label}
    </Typography>
    {children}
  </Box>
);
